// src/pages/Products.js

import React from 'react';
// NEW: Import the main page component
import ProductsPage from '../components/products/index';

const Products = () => {
  return (
    <div className="w-full">
      <ProductsPage />
    </div>
  );
};

export default Products;